module.exports = __webpack_public_path__ + "static/media/icon-login-linkedin.a8f32428.svg";